import Reveal from "../../../src/components/Reveal";

const SECTORS = [
  "Constructoras",
  "Sector financiero",
  "Cooperativas",
  "Comercio exterior",
  "Sector solidario",
  "Inversionistas",
  "Entidades públicas",
  "Empresas familiares",
];

export default function TrustSection() {
  return (
    <section
      data-testid="home-trust"
      className="bg-white border-y border-slate-100"
    >
      <div className="container-x py-12 md:py-16">
        <Reveal className="text-center mb-8">
          <span className="overline">Sectores que acompañamos</span>
        </Reveal>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-y-6 gap-x-8 items-center">
          {SECTORS.map((s, i) => (
            <Reveal key={s} delay={i * 60}>
              <p className="text-center text-sm md:text-[15px] font-medium text-slate-500 tracking-wide hover:text-navy-900 transition-colors">
                {s}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}